import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendarRangeComponent } from './calendar-range.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [CalendarRangeComponent],
  imports: [CommonModule, FormsModule],
  exports: [CalendarRangeComponent],
})
export class CalendarRangeModule {}
